import Point from 'ol/geom/Point';
import { Feature } from 'ol';
import { TrackEntity } from '@/TrackEntity';
import { Styles } from './Styles';
import Ordered from './OrderHelper';

export class PointFeatureSubclass extends Feature<Point> {
    getGeometry(): Point {
        return super.getGeometry()!
    }
}

export default abstract class PointFeature extends PointFeatureSubclass implements Ordered {
    track: TrackEntity
    order: number
    constructor(geometryOrProperties: Point|undefined, track: TrackEntity, order: number) {
        super(geometryOrProperties)
        this.track = track
        this.order = order
    }
}